<div class="fixed inset-0 z-50 flex items-center justify-center p-4" aria-modal="true">
  <!-- Background Overlay -->
  <div class="fixed inset-0 bg-[#363738] bg-opacity-25 backdrop-blur-sm transition-opacity dark:bg-[#3333331f]"
    (click)="onCloseModal()"></div>

  <!-- Modal Container -->
  <div
    class="relative flex w-full max-w-lg flex-col overflow-hidden rounded-lg border border-zinc-950/10 bg-white shadow-xl dark:border-white/10 dark:bg-zinc-950">

    <!-- Header -->
    <div class="border-b border-zinc-200 px-4 py-2 dark:border-white/10">
      <div class="flex items-center justify-between">
        <h3 class="heading">Reason for Rejection</h3>
        <div class="ml-3 flex h-7 items-center space-x-4">
          <button (click)="onCloseModal()"
            class="rounded-sm bg-white text-zinc-500 hover:text-zinc-700 focus:ring-2 focus:ring-primary dark:bg-white/5 dark:text-white dark:hover:text-zinc-300"
            type="button">
            <span class="sr-only">Close panel</span>
            <svg aria-hidden="true" class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="1.5"
              viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </button>
        </div>
      </div>
      <p class="text-sm-light mt-0.5">
        Please mention the reason for disapproved "<span class="font-medium">{{ documentLabel }}</span>".
      </p>
    </div>

    <!-- Content -->
    <div class="flex-1 space-y-2 px-4 py-3">
      <label class="subheading">
        Reason
      </label>
      <textarea [(ngModel)]="reasonText" rows="4"
        class="w-full rounded-lg border border-zinc-950/10 dark:border-white/10 bg-white dark:bg-zinc-900 p-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"></textarea>
    </div>

    <!-- Footer -->
    <div class="flex justify-end gap-3 border-t border-zinc-200 px-4 py-2 dark:border-white/10">
      <button type="button" (click)="onCloseModal()" class="btn-outline btn-outline-secondary">
        Cancel
      </button>
      <button type="button" (click)="onSubmit()" [disabled]="!reasonText.trim()"
        class="btn btn-danger disabled:opacity-50 disabled:cursor-not-allowed">
        Submit
      </button>
    </div>
  </div>
</div>
